/**
 * Event cursors are `<epoch>.<sequence>`: the epoch names one server process
 * (an event broker), the sequence counts the events it has published. Whether
 * `cursor` is at or after `since`; cursors from different processes are
 * unordered, so they never are.
 */
export function eventCursorReached(cursor: string | undefined, since: string | undefined) {
  if (!cursor || !since) return false
  const [epoch, sequence] = cursor.split(".")
  const [sinceEpoch, sinceSequence] = since.split(".")
  if (!epoch || epoch !== sinceEpoch) return false
  return Number(sequence) >= Number(sinceSequence)
}
